export default __webpack_public_path__ + "static/media/G89A7277-2_tn.9ca238ea.jpg";